import { set, useDebounceFn } from '@vueuse/core';
import { type MaybeRefOrGetter, ref, toValue, useTemplateRef } from 'vue';

type Config = {
  debounceTimeInMs?: number;
};

export function useInputLimit(limit: MaybeRefOrGetter<number>, config?: MaybeRefOrGetter<Config>) {
  const inputRef = useTemplateRef<HTMLInputElement | HTMLTextAreaElement>('inputRef');
  const currentLength = ref(0);
  const limitValue = toValue(limit);

  function updateCurrentLength() {
    set(currentLength, inputRef.value?.value.length ?? 0);
  }

  const debounceTimeInMs = toValue(config)?.debounceTimeInMs ?? 0;
  const debouncedUpdateCurrentLength = useDebounceFn(() => updateCurrentLength(), debounceTimeInMs);

  return { inputRef, limit: limitValue, currentLength, updateCurrentLength, debouncedUpdateCurrentLength };
}
